import { Box, Divider, SxProps, Theme, Typography, useTheme } from "@mui/material";

type GroupsTitleProps = {
    title: string;
    sx?: SxProps<Theme>
};

export const GroupsTitle = ({ title,sx }: GroupsTitleProps) => {
    const theme = useTheme();
    return (
        <Box sx={{...sx}}>
            <Typography
                color="primary"
                fontWeight="bold"
                variant="subtitle1"
                sx={{
                    textTransform: "capitalize",
                }}
                align="left"
            >
                {title}
            </Typography>
            <Divider
                sx={{
                    paddingLeft: 0,
                    borderBottom: `2px solid ${theme.palette.primary.main}`,
                    marginTop: 2,
                    marginBottom: 4,
                }}
            />
        </Box>
    );
};
